import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../../routes/useLanguageSync';
import { useSEO } from '../../hooks/useSEO';
import { organizationJsonLd, websiteJsonLd } from '../../config/seo';
import HeroSection from '../../components/HeroSection/HeroSection';
import SectionHeading from '../../components/SectionHeading/SectionHeading';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import PartnersSection from '../../components/PartnersSection/PartnersSection';
import { services } from '../../data/services';
import styles from './Home.module.css';

const Home: React.FC = () => {
  const { t } = useTranslation();
  const getPath = useLocalizedPath();

  const seo = useSEO({
    titleKey: 'seo.home.title',
    descriptionKey: 'seo.home.description',
    routeKey: 'home',
    structuredData: [organizationJsonLd, websiteJsonLd],
  });

  return (
    <div className={styles.home}>
      {seo}
      <HeroSection />

      <section className={styles.servicesSection}>
        <div className="container">
          <SectionHeading
            title={t('home.servicesTitle')}
            subtitle={t('home.servicesSubtitle')}
          />
          <div className={styles.servicesGrid}>
            {services.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
        </div>
      </section>

      <section className={styles.aboutSection}>
        <div className="container">
          <SectionHeading
            title={t('home.aboutTitle')}
            accentColor="var(--color-blue)"
          />
          <p className={styles.aboutText}>{t('home.aboutText')}</p>
          <Link to={getPath('about')} className={styles.aboutLink}>
            {t('home.aboutCta')} &rarr;
          </Link>
        </div>
      </section>

      <PartnersSection />

      <section className={styles.ctaSection}>
        <div className="container">
          <h2 className={styles.ctaTitle}>{t('home.ctaTitle')}</h2>
          <p className={styles.ctaText}>{t('home.ctaText')}</p>
          <Link to={getPath('contact')} className={styles.ctaButton}>
            {t('home.ctaButton')}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
